import {
  APP_NAME,
  RequestMethod,
  SubscriptionListType,
} from '~/shared/constants/commonConstants'
import { ApiService } from '~/shared/services/api'
import { IRequestOptions, IResponseResult } from '~/shared/types/apiTypes'
import { IRawSubscription } from '~/shared/types/subscriptionsTypes'

export class SubscriptionsApi {
  private api: ApiService

  constructor(api: ApiService) {
    this.api = api
  }

  getSubscriptionList({
    cohort,
    type,
    uuid,
    tags,
  }: {
    cohort: string
    type: typeof SubscriptionListType[keyof typeof SubscriptionListType]
    uuid: string
    tags: string
  }): Promise<IResponseResult<{ plans: IRawSubscription }>> {
    const options: IRequestOptions = {
      method: RequestMethod.GET,
      params: { plan_type: type, uuid, tags },
    }

    return this.api.makeRequest<{ plans: IRawSubscription }>(
      `v2/plans/${APP_NAME}/${cohort}`,
      options,
    )
  }
}
